<template>
  <!-- 视频弹窗 -->
  <el-dialog width="900px" class="video-dialog" append-to-body :title="currentVideo.title" :visible.sync="dialogVisibleVideo" @close="close">
    <div class="video-style">
      <!-- <div class="title-style">{{currentVideo.title}}</div> -->
      <video v-if="currentVideo.videoUrl" ref="video" :class="[screenWidth <= 1285 ? 'video-width' : '']"
        controls
        controlslist="nodownload noplaybackrate"
        class="video-player"
        disablePictureInPicture
        height="480" 
        width="854" 
        autoplay>
        <source :src="currentVideo.videoUrl" type="video/mp4" />
      </video>
      <div v-else>{{ $i18.language('暂无数据') }}</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    currentVideo: {
      type: Object,
    },
    saveTime: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data() {
    return {
      dialogVisibleVideo: false,
      screenWidth: null,
      videoDuration: null,
    }
  },

  mounted() {},
  created() {
    this.screenWidth = document.documentElement.clientWidth
  },
  methods: {
    getVideoTime() {
      if(!this.saveTime) {
        this.dialogVisibleVideo = false
        this.$emit('clearVideo')
        return
      }
      this.$nextTick(() => {
        this.videoDuration = this.$refs.video.currentTime
        let params = {
          id: this.currentVideo.id, //id 由列表获取
          duration: this.videoDuration, //时长
          sessionKey: new Date().getTime(), //会话唯一key
          pageAddress: window.location.href, //页面地址
        }
        this.$api.help.saveViewTime(params).then((res) => {
          if (res && res.code == 200) {
            this.dialogVisibleVideo = false
            this.$emit('clearVideo')
          }
        })
      })
    },
    open() {
      this.dialogVisibleVideo = true
      this.handleAddLogs()
    },
    // 视频添加埋点
    handleAddLogs() {
      let data = sessionStorage.getItem("webLog")
      if(data) {
        data = JSON.parse(data)
        let {onlyKey, title} = this.currentVideo
        let key = onlyKey || title
        this.$set(data, 'attribute', `helper_video:${key}`);
        this.$api.logs.addWebLogs(data)
      }
    },
    close() {
      this.getVideoTime()
      
    },
  },
}
</script>

<style lang="scss" scoped>
.video-dialog {
  /deep/.el-dialog {
    max-width: 900px!important;
  }
}
.title-style {
  font-size: 20px;
}
.video-style {
  width: 100%;
  text-align: center;
}
.video-width {
  width: 100%;
}
</style>

